import { PublicNav, Footer } from "@/components/layout/PublicLayout";
import { SectionHead, faqItems } from "./Landing";
import { useContent } from "@/context/ContentContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Search, Wallet, MousePointerClick, Rocket } from "lucide-react";

export function HowItWorks() {
  const { t } = useContent();
  const steps = [
    [Search, t("howto.step1.title", "Choisir un service"), t("howto.step1.desc", "Parcourez le catalogue, filtrez par plateforme, catégorie et niveau de qualité. Chaque service affiche prix, vitesse, chute et recharge.")],
    [Wallet, t("howto.step2.title", "Recharger le portefeuille"), t("howto.step2.desc", "Ajoutez des fonds via carte bancaire, Mobile Money (PawaPay) ou USDT TRC20. Le solde est crédité après confirmation côté serveur.")],
    [MousePointerClick, t("howto.step3.title", "Passer commande"), t("howto.step3.desc", "Sélectionnez le service, entrez la cible et la quantité. Le prix est calculé en temps réel et débité du portefeuille.")],
    [Rocket, t("howto.step4.title", "Suivre la livraison"), t("howto.step4.desc", "La commande est routée automatiquement vers un fournisseur. Suivez le statut et l'historique d'événements en direct.")],
  ];
  return (
    <div>
      <PublicNav />
      <div className="mx-auto max-w-4xl px-5 py-16">
        <SectionHead eyebrow={t("howto.eyebrow", "Guide")} title={t("howto.title", "Comment ça marche")} subtitle={t("howto.subtitle", "De la sélection du service à la livraison, en quatre étapes simples.")} />
        <div className="mt-12 space-y-6">
          {steps.map(([Ico, ttl, d], i) => (
            <div key={ttl} className="flex gap-5 rounded-xl border border-border bg-card p-6">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground"><Ico className="h-5 w-5" /></div>
              <div>
                <div className="text-xs font-semibold text-accent">{t("howto.step_label", "ÉTAPE")} {i + 1}</div>
                <h3 className="mt-1 font-display text-lg font-semibold">{ttl}</h3>
                <p className="mt-1 text-sm text-muted-foreground">{d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export function Faq() {
  const { t } = useContent();
  return (
    <div>
      <PublicNav />
      <div className="mx-auto max-w-3xl px-5 py-16">
        <SectionHead eyebrow={t("faq.eyebrow", "FAQ")} title={t("faq.title", "Questions fréquentes")} subtitle={t("faq.page.subtitle", "Tout ce que vous devez savoir sur la plateforme.")} />
        <Accordion type="single" collapsible className="mt-8">
          {faqItems(t).map((f, i) => (
            <AccordionItem key={i} value={`i${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-display">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <Footer />
    </div>
  );
}
